
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAEH6FoD32kZqZSgYNHnmICavgBx4Qtdhs",
  authDomain: "dwilliams-74b9e.firebaseapp.com",
  projectId: "dwilliams-74b9e",
  storageBucket: "dwilliams-74b9e.appspot.com",
  messagingSenderId: "878837419108",
  appId: "1:878837419108:web:30fdac1f69c54819cc2371",
  measurementId: "G-512YMZ3W1H"
};

const app = initializeApp(firebaseConfig);

// Analytics: Carga diferida para no bloquear el renderizado inicial
if (typeof window !== 'undefined') {
  // Solo cargamos analytics despues del primer renderizado
  setTimeout(() => {
    import('firebase/analytics').then(({ getAnalytics }) => {
      getAnalytics(app);
    });
  }, 3000);
}

// Auth: exportamos una funcion lazy para no inicializar en el critical path
let _auth = null;
export const getAuthInstance = async () => {
  if (!_auth) {
    const { getAuth } = await import('firebase/auth');
    _auth = getAuth(app);
  }
  return _auth;
};

// Para compatibilidad con codigo existente: exportamos auth como proxy
// que se resuelve lazily. Los modulos que lo usan sincrónicamente
// ahora reciben una promesa o pueden migrar a getAuthInstance()
export const auth = {
  get currentUser() {
    return _auth ? _auth.currentUser : null;
  },
  signOut: async () => {
    const a = await getAuthInstance();
    return a.signOut();
  }
};

export const db = getFirestore(app);
export const storage = getStorage(app);